<template>
	<span class="flex items-center gap-6 w-full">
		<slot>
			<BaseUserAvatar v-if="user" :url="user.avatar" :name="user.name" />
			<BaseUserAvatar v-else />
			<span class="truncate w-full">{{ user ? user.name : 'Anonymous' }}</span>
		</slot>
		<span v-if="$slots.aside" class="flex-none ml-auto">
			<slot name="aside" />
		</span>
	</span>
</template>

<script>
export default {
	name: 'UserListItem',
	props: {
		user: {
			type: Object,
			default: null,
		},
	},
}
</script>
